module.exports = __webpack_public_path__ + "static/media/img-3.ad18d839.jpg";